import Swiper from 'swiper/bundle';

const sliderSelector = '.ouw-video-slider .swiper';

function runSlider() {
    const swiper = new Swiper(sliderSelector, {
        loop: false,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        autoplay: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
            }
        }
    });
}

//todo delete this if we use [video] shortcode
function videoNav() {
    [...document.querySelectorAll('.ouw-video video')].forEach(video => {
        video.addEventListener('play', function () {
            video.dataset.playing = 'true';
        });
        video.addEventListener('pause', function () {
            video.dataset.playing = 'false';
        });
        video.addEventListener('ended', function () {
            video.dataset.playing = 'false';
        });
        

    })
}

export { runSlider, videoNav };